var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 67,
    viewBox: "0 0 135 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4888 38.4567V25.9165C48.4888 23.0341 49.6338 20.2697 51.672 18.2316C53.7102 16.1934 56.4745 15.0483 59.357 15.0483C62.2394 15.0483 65.0037 16.1934 67.0419 18.2316C69.0801 20.2697 70.2251 23.0341 70.2251 25.9165V27.5844C70.2251 28.0278 70.049 28.4531 69.7354 28.7667C69.4218 29.0802 68.9966 29.2564 68.5531 29.2564C68.1097 29.2564 67.6844 29.0802 67.3708 28.7667C67.0572 28.4531 66.8811 28.0278 66.8811 27.5844V25.9165C66.8811 23.921 66.0884 22.0072 64.6773 20.5962C63.2663 19.1851 61.3525 18.3924 59.357 18.3924C57.3614 18.3924 55.4476 19.1851 54.0366 20.5962C52.6255 22.0072 51.8328 23.921 51.8328 25.9165V38.4567",
    fill: "#35B36F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7331 38.4565H45.9807C43.2104 38.4565 40.9646 40.7023 40.9646 43.4726V60.1929C40.9646 62.9632 43.2104 65.209 45.9807 65.209H72.7331C75.5034 65.209 77.7492 62.9632 77.7492 60.1929V43.4726C77.7492 40.7023 75.5034 38.4565 72.7331 38.4565Z",
    fill: "#FFCF26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.029 54.3409C61.029 54.7844 60.8528 55.2097 60.5393 55.5232C60.2257 55.8368 59.8004 56.013 59.357 56.013C58.9135 56.013 58.4882 55.8368 58.1747 55.5232C57.8611 55.2097 57.6849 54.7844 57.6849 54.3409V49.3249C57.6849 48.8814 57.8611 48.4561 58.1747 48.1426C58.4882 47.829 58.9135 47.6528 59.357 47.6528C59.8004 47.6528 60.2257 47.829 60.5393 48.1426C60.8528 48.4561 61.029 48.8814 61.029 49.3249V54.3409Z",
    fill: "#3DBD78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M45.9807 38.4565C44.6503 38.4565 43.3745 38.985 42.4338 39.9257C41.4931 40.8664 40.9646 42.1423 40.9646 43.4726V60.1929C40.9646 61.5233 41.4931 62.7991 42.4338 63.7398C43.3745 64.6805 44.6503 65.209 45.9807 65.209H59.3569V38.4565H45.9807Z",
    fill: "#000064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.533 20.6777C122.751 19.6114 124.275 19.6114 124.493 20.6777L125.33 24.7747C125.41 25.1672 125.717 25.474 126.11 25.5542L130.207 26.3916C131.273 26.6096 131.273 28.1331 130.207 28.3511L126.11 29.1885C125.717 29.2687 125.41 29.5755 125.33 29.968L124.493 34.065C124.275 35.1313 122.751 35.1313 122.533 34.065L121.696 29.968C121.616 29.5755 121.309 29.2687 120.916 29.1885L116.819 28.3511C115.753 28.1331 115.753 26.6096 116.819 26.3916L120.916 25.5542C121.309 25.474 121.616 25.1672 121.696 24.7747L122.533 20.6777Z",
    fill: "#FFC747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0389 4.79346C12.2569 3.72713 13.7805 3.72712 13.9984 4.79346L15.0957 10.1621C15.176 10.5546 15.4827 10.8614 15.8752 10.9416L21.2439 12.0389C22.3102 12.2569 22.3102 13.7805 21.2439 13.9984L15.8752 15.0957C15.4827 15.176 15.176 15.4827 15.0957 15.8752L13.9984 21.2439C13.7805 22.3102 12.2569 22.3102 12.0389 21.2439L10.9416 15.8752C10.8614 15.4827 10.5546 15.176 10.1621 15.0957L4.79346 13.9984C3.72713 13.7805 3.72712 12.2569 4.79346 12.0389L10.1621 10.9416C10.5546 10.8614 10.8614 10.5546 10.9416 10.1621L12.0389 4.79346Z",
    fill: "#2CB3A5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.5822,
    y: 13.3762,
    width: 9.19615,
    height: 9.19615,
    transform: "rotate(31.3518 97.5822 13.3762)",
    fill: "#F6A447"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.6888,
    y: 41.3145,
    width: 5.45717,
    height: 5.45717,
    transform: "rotate(-30 89.6888 41.3145)",
    fill: "#ED706E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockTheme);
export default __webpack_public_path__ + "static/media/UnlockTheme.d70a3053.svg";
export { ForwardRef as ReactComponent };